






















































































import Vue from "vue";
import HexagonAvatar from "@/components/HexagonAvatar.vue";
import HexagonAbout from "@/components/HexagonAbout.vue";
import Footer from "@/components/Footer.vue";

export default Vue.extend({
  name: "About",
  components: {
    HexagonAvatar,
    HexagonAbout,
    Footer,
  },
  computed: {
    progressColor() {
      return this.$vuetify.theme.dark ? "warning" : "accent";
    },
  },
  data: () => ({
    listSkill: [
      {
        text: "Javascript",
        progress: 80,
      },
      { text: "PHP", progress: 70 },
      { text: "CSS3", progress: 80 },
      {
        text: "HTML5",
        progress: 80,
      },
      {
        text: "Java",
        progress: 70,
      },
      {
        text: "SQL",
        progress: 70,
      },
    ],
    listBio: [
      {
        text: "Pinrang, South Sulawesi, Indonesia",
        subtitle: "Address",
        icon: "mdi-map-marker",
      },
      { text: "+6285255136996", subtitle: "Phone", icon: "mdi-phone" },
      { text: "02 May 1996", subtitle: "Birthday", icon: "mdi-calendar" },
      {
        text: "Bachelor of Computer Science : Technical Information",
        subtitle: "Universitas Muhammadiyah Parepare",
        icon: "mdi-certificate",
      },
    ],
    listAbout: [
      {
        icon: "mdi-speedometer",
        title: "Fast",
        text: "Fast load times and lag free interaction, my highest priority.",
        animated:
          "animate__animated animate__lightSpeedInRight animate__delay-2s",
      },
      {
        icon: "mdi-responsive",
        title: "Responsive",
        text: "My layouts will work on any device, big or small.",
        animated:
          "animate__animated animate__lightSpeedInRight animate__delay-3s",
      },
      {
        icon: "mdi-lead-pencil",
        title: "Intuitive",
        text: "Strong preference for easy to use, intuitive UI/UX.",
        animated:
          "animate__animated animate__lightSpeedInRight animate__delay-4s",
      },
      {
        icon: "mdi-rocket-launch",
        title: "Dynamic",
        text: "Websites don't have to be static, I love making pages come to life.",
        animated:
          "animate__animated animate__lightSpeedInRight animate__delay-5s",
      },
    ],
  }),
});
